export default __webpack_public_path__ + "static/media/people.f499fe63.svg";